/* Sitewide variable text */

export default
  {
    personal: [
      {
        section: 'Personal',
        name: 'Lawrence Castillo',
        email: 'Lawrence.g.castillo@gmail.com',
        domain: 'http://lawrencecastillo.com',
        keywords: 'lawrence castillo, web developer, software engineer, new york, nyc, web engineer, front-end developer, ux/ui developer, manhattan, react developer, node developer, fullstack developer, developer, engineer, web, backend developer, backend engineer, lawrence gabriel castillo, javascript, js, react.js, node.js, sql, nosql, web designer',
        background_url: 'https://images.unsplash.com/photo-1503149779833-1de50ebe5f8a',
        location: 'NYC',
        headline: 'Webhead in NYC',
        description: 'I\'m a software developer in New York City, NY. Welcome to my personal portfolio page where you can view some of my web app projects, my academic achievements, as well as my employment history. Have a look around and feel free to contact me!',
        image: 'https://avatars1.githubusercontent.com/u/33098457?s=460&u=65f0d2c78bc9870e13e0b2147cc8f533a175d497&v=4',
        about: 'Hey, I\'m Lawrence 👋 I\'m a fanatic about new technologies including microprocessors for around-the-home projects and all things involving AR... It\'s the future of tech. When I\'m not geeking out on new technology or coding apps for the web, you can generally find me getting my hands dirty with everything from carving woodblocks and making paper, to electroplating silver for Daguerreotypes. Say hi and let\'s talk about your project: Lawrence.g.castillo@gmail.com',
        skills:
        [
          'JavaScript', 'TypeScript', 'Swift', 'SwiftUI', 'React', 'React Native', 'Hooks', 'MobX', 'SASS', 'MongoDB', 'Firebase', 'Netlify'
        ],
        social:       
        [
          {
            id: 1,
            name: 'Github',
            icon_url: '/images/social-icons/GitHub-Mark.png',
            profile_url: 'https://github.com/lawrencecastillo'
          },
          {
            id: 2,
            name: 'LinkedIn',
            icon_url: '/images/social-icons/linkedin-2.png',
            profile_url: 'https://www.linkedin.com/in/lawrence-gabriel-castillo/'
          },
          {
            id: 3,
            name: 'Resume',
            icon_url: '/images/social-icons/file-icon.png',
            profile_url: '/docs/LawrenceCastillo_Resume.pdf'
          },
        ],
        interests:
        [
          'Making tools from microprocessors', 'Soldering gadgets', 'Photographing architecture', 'Reading critical art texts', 'Running for fun',
        ],
      },
    ],
    groups: [
      {
        experience: 
        [
          {
            id: 1,
            name: 'Threshold.co',
            image_url: '/images/Threshold-logo.jpg',
            site_url: 'https://www.threshold.co/',
            location: 'Remote',
            timeframe: 'May 2020 - Current',
            role: 'Web Developer (Frontend)',
            description: 'Implementing front-end (Preact, JSX, SASS) components and testing suite (Ghost Inspector); this is a paid part-time position',
            highlights: ['Optimized Canvas-based image cropping and uploading tool to enhance image quality and usability','Implemented UI for user-based worklflows (JavaScript/ SASS) for several key initiatives, including onboarding','Created test suite and designed single function test modules to be stacked to create comprehensive tests'],
          },
          {
            id: 2,
            name: 'HelixMusic.app',
            image_url: '/images/Helix-Music-logo.jpg',
            site_url: 'https://www.helixmusic.app/',
            location: 'Remote',
            timeframe: 'July 2020 - Current',
            role: 'Consultant/ iOS Mobile Developer (UI)',
            description: 'Building UI in React Native based on Figma design layouts; this is a paid contract position through MVP',
            highlights: ['Implemented UI for user auth (React Native/ Hooks/ MobX) workflow with emphasis on error handling and verification','Configured app to serve language translations with Expo localization and the i18n library'],
          },
          {
            id: 3,
            name: 'Daily Zone',
            image_url: '/images/Daily-Zone-app.jpg',
            site_url: '',
            location: 'Remote',
            timeframe: 'September 2020 - Current',
            role: 'iOS Mobile Developer (UI)',
            description: 'Refactoring front-end code in Swift/ SwiftUI to add styles/animation; this is an equity position',
            highlights: [],
          },
          {
            id: 4,
            name: 'On The Level',
            image_url: '/images/On-The-Level-logo.jpg',
            site_url: 'https://www.studioonthelevel.com/',
            location: 'Remote',
            timeframe: 'July 2020 - Current',
            role: 'Consultant/ Website Builder',
            description: 'Building/ customizing Squarespace web solutions to match designer layout; this is a paid consultant position',
            highlights: [],
          },
          {
            id: 5,
            name: 'WeWork Labs',
            image_url: '/images/WeWork-Labs-logo.jpg',
            site_url: 'https://www.wework.com/labs/',
            location: 'NYC',
            timeframe: 'June 2019 - August 2019',
            role: 'Web Developer (Full-stack) intern',
            description: 'Fullstack (React, Node, Airtable) web development role developing two product initiatives/ proof of concepts over two agile cycles',
            highlights: ['Developed custom matching algorithm (Node.js) and documentation to predict candidate success','Developed solution (React) to prioritize user feedback and route it to the appropriate department','Wrote web scraping app (JS) to demo in-house data gathering as possible alternative to 3rd-party service'],
          },
          {
            id: 6,
            name: 'Freelance Web Designer',
            image_url: '/images/Freelance-web-designer.jpg',
            site_url: 'http://lawrencecastillo.com/',
            location: 'NYC',
            timeframe: 'April 2014 - Current',
            role: 'Sole-Proprietor, Web Designer & Photographer/Editor',
            description: 'Web designer, production tech, photographer, photo editor - side gig to finish school',
            highlights: ['Provide web management services and technical expertise to commercial multimedia production houses','Customize off-the-shelf web solutions for small-scale clients, with emphasis on UI/UX design','Provide digital photography and editing services (Adobe Creative Suite) for private and commercial clients'],
          },
        ],
      },
      {
        projects: 
        [
          {
            id: 1,
            name: 'React Template: "Ada"',
            image_url: 'https://lh3.googleusercontent.com/pw/ACtC-3d2kAf93fcQGJgm-55gw7IQDa98EtejQB8M3KizMIY3zEhUdnA2HqWasuOhLFQw-pKk0b9unaRqUD0Yd38cfaZ4urUS_39vQZyiU9NeW4jcIVUaK4xcAfUF0S8fMpJubn_Go0BYDwcgBxekuci35UMJYw=w1000-h667-no?authuser=0',
            site_url: 'https://github.com/LawrenceCastillo/ada-theme-react-template',
            location: 'NYC',
            timeframe: '2020',
            role: 'Front-end',
            description: 'While developing this website for my personal use, I decided early on I wanted to be able to share the site. React templates are often hard to decipher so I made this one simple by putting all data in one place and creating simple switches to change a collection look instantly. Deployed via Netlify.',
          },
          {
            id: 2,
            name: 'Matchmaking App',
            image_url: 'https://lh3.googleusercontent.com/pw/ACtC-3fusEHLl4ACUV4rFYIevm9KlvF4jOBseiPCqnu3XKbHVMxCgvRoRHXfbzqvqYdhQcWZq1PRe2fFTsgraTDTfOrsIDUSgmXA80FyOlcnh6j1PY0hOwSNu6Qrhjz6DXf-uMxrBge3SYSyz9hZF8EZcQkkuQ=w1000-h667-no?authuser=0',
            site_url: 'https://github.com/LawrenceCastillo/LLL',
            location: 'NYC',
            timeframe: '2019',
            role: 'Fullstack',
            description: 'Matchmaking application created to blindly pair individuals based on guidelines from "The Four Tendencies" by Gretchen Rubin -- but only for a limited time. I designed and developed the app in PHP and MySQL (LAMP) and deployed it (temporarily) from my home network via Raspberry Pi/ Apache server with port-forwarding.',
          },
          {
            id: 3,
            name: 'Silent Alarm App',
            image_url: 'https://lh3.googleusercontent.com/pw/ACtC-3dElfLFMyuw3N8_IzplwCHqEjq2FNAuvqWvCAHtPEx1aFN2qNs1UHG5VpvllMy69DADZfudA9aSoNf79TjrZofbMR8qey8CDnLLnsVb5ef5NJl2WCjHjefuZcAvYfchqv-_W_MAZ8nk2xgZqJYe0FNkLg=w1000-h667-no?authuser=0',
            site_url: 'https://github.com/LawrenceCastillo/fashion_forward',
            location: 'NYC',
            timeframe: '2019',
            role: 'Team back-end developer',
            description: 'Official HackNY entry & winner of best social good. This app is designed to curb domestic abuse by fronting as a clothing outlet but hiding panic buttons capable of auto-texting local PD. I implemented parts of the backend (Node.js) including connectivity to MongoDB, authentication (Passport), and Twilio for messaging.',
          },
          {
            id: 4,
            name: 'Photowall App',
            image_url: 'https://lh3.googleusercontent.com/pw/ACtC-3dXeKyUpoUXt8Ujb_m_nqZUQVnmWycwq4R80SrfoOkc_ZLLVhz6SHxIWDB9Kpo0wYGA7jqiAbFyIInHLfWcEMSSSienpjzuyQHW_1PcQPiPfVbGEpQ5djOyZ0MOCPF7gqjULSZ5B6VXzl8o8Ysr_MA3IA=w1000-h667-no?authuser=0',
            site_url: 'https://github.com/LawrenceCastillo/photowall',
            location: 'NYC',
            timeframe: '2020',
            role: 'Fullstack',
            description: 'The Photowall app allows users to create image posts with descriptions, delete posts, and add comments. Built with React, Redux, React-router, Firebase, and deployed via Netlify, the app is the result of completing an online course I undertook in order to refine my React/Redux skillset.',
          },
        ],
      },
      {
        education:
        [
          {
            id: 1,
            name: 'Hunter College / CUNY',
            image_url: '',
            site_url: 'https://hunter.cuny.edu/',
            location: 'NYC',
            timeframe: ' Grad 2020',
            role: 'Bachelor of Science (BS) degree in Computer Science',
            description: 'Graduated with on Jan 31, 2020. Coursework included a focus on object oriented programming (OOP), algorithms, databases, data structures, and discreet mathematics, with an emphasis in C++, MySQL, Bash, and Python.',
            highlights: [],
          },
          {
            id: 2,
            name: 'Tech Talent Pipeline (TTP)',
            image_url: '',
            site_url: 'https://ttp.nyc/cuny-programs',
            location: 'NYC',
            timeframe: 'Summer 2019',
            role: '2019 Resident + Fullstack Application Bootcamp',
            description: 'Intensive fullstack web application bootcamp with focus on MERN stack (JS, React, Node, MongoDB, Express ), with additional study in Git, MySQL, authentication with Passport, and deployment to Heroku.',
            highlights: [],
          },
          {
            id: 3,
            name: 'Allan Hancock College',
            image_url: '',
            site_url: 'https://www.hancockcollege.edu/',
            location: 'CA',
            timeframe: 'Completed 2009',
            role: 'Associate of Science (AS) degree in Electronics',
            description: 'AS degree completed in \'09. Coursework included digital circuit design and analysis, measurement and instrumentation, and programming',
            highlights: [],
          },
        ],
      },
    ],
  }
